import { render, staticRenderFns } from "./ViewOrderCreationBrands.vue?vue&type=template&id=90212326&"
import script from "./ViewOrderCreationBrands.vue?vue&type=script&lang=ts&"
export * from "./ViewOrderCreationBrands.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOrderCreationBrands.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports